<template>
  <div class="inquire-app">
    <mt-header fixed title="礼品卡">
      <router-link to="/auth-app" slot="left">
        <mt-button icon="back"></mt-button>
      </router-link>
    </mt-header>
    <div style="height:45px;"></div>
    <div class="flexsb inquire-box flexa">
      <el-input v-model="account" style="margin-right:20px;" maxlength="20" placeholder="请输入卡号"></el-input>
      <el-button type="primary" class="p-fw" style="width:100px;font-size:14px;" @click="inquire">筛选</el-button>
    </div>
    <div class="count-box">
      <div>总数：</div>
      <div>
        <span class="p-fw">{{cardList.length}}</span>
        <span style="margin-left:10px;">张</span>
      </div>
    </div>
    <div class="list">
      <div class="item" v-for="(item,index) of cardList" :key="index" @click="toDetail(item)">
        <div class="flexa">
          <span class="account p-666">{{item.card_no}}</span>
          <span style="margin-left: 16px;">{{item.statusInWords}}</span>
        </div>
        <div class="flexa">
          <span class="p-FA800A p-fw">{{item.balance}}</span>
          <span class="p-999" style="margin-left: 6px;">{{item.currency}}</span>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { aPost2 } from "@/utils/request";
import api from "@/utils/api";
export default {
  data() {
    return {
      account: "",
      card_no: "",
      cardList: []
    };
  },
  methods: {
    async getCardList() {
      let params = {
        order_no: this.order_no,
        card_no: this.card_no
      };
      let res = await aPost2(api.queryCard, params);
      if (res.data.errCode === "99999") {
        if (res.data.retData.length > 0) {
          let data = res.data.retData;
          data.forEach(e => {
            e.balance = (e.balance / 100).toFixed(1);
            switch (e.status) {
              case "00":
                e.statusInWords = "正常";
                break;
              case "01":
                e.statusInWords = "未启用";
              case "03":
                e.statusInWords = "正在制卡";
              case "10":
                e.statusInWords = "暂停";
              case "11":
                e.statusInWords = "锁卡";
              case "18":
                e.statusInWords = "临时暂停";
              case "90":
                e.statusInWords = "分配锁定";
              case "99":
                e.statusInWords = "已注销";
              default:
                break;
            }
          });
          this.cardList = res.data.retData;
        }
      } else {
        Toast.fail(`${res.data.errMsg}`);
      }
    },
    inquire() {
      if (!this.account) {
        Toast.fail("篩選卡號不能為空");
        return false;
      }
      let cardList = this.cardList;
      let tempArr = [];
      // console.log(cardList.some(e => e.card_no === this.account));
      if (cardList.some(e => e.card_no === this.account)) {
        cardList.forEach(e => {
          if (e.card_no === this.account) {
            this.toDetail(e);
          }
        });
      } else {
        Toast.fail("查無此卡！");
      }
    },
    toDetail(item) {
      this.$router.push({
        name: "card-detail-app",
        params: { card_detail: item }
      });
    }
  },
  mounted() {
    if (this.$route.params.order_no || sessionStorage.getItem("order_no")) {
      this.order_no =
        this.$route.params.order_no || sessionStorage.getItem("order_no");
      this.getCardList();
    } else {
      Toast.fail("訂單號丟失，請重新打開此頁面！");
    }
  }
};
</script>

<style lang="scss" scoped>
.inquire-app {
  /* font-size: 24px; */
  background: #f6f5fa;
  height: 100%;
  /deep/ .el-input__inner {
    font-size: 20px;
  }
  /deep/ .mint-header {
    font-size: 22px;
    height: 60px;
    background: linear-gradient(to bottom, #37363b, #424244);
  }
  /deep/ .mint-header-title {
    height: 60px;
    line-height: 60px;
    font-weight: bold !important;
  }
  .inquire-box {
    padding: 20px;
  }
  .count-box {
    display: flex;
    align-items: center;
    background: #e3e2e7;
    padding: 20px;
    font-size: 22px;
  }
  .list {
    background: #fff;
    font-size: 20px;
    .item {
      display: flex;
      justify-content: space-between;
      padding: 20px 0;
      margin: 0 20px;
      border-bottom: 1px solid #eee;
    }
  }
}
</style>